import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { useRouter } from 'next/router';

import { Icon } from '@gogovan/entier-web-core/ext/mui/Icon';

import {
  Container,
  PhoneContainer,
  DescriptionContainer,
  TextContainer,
  IconContainer,
} from './floating-chat-button.style';

const FloatingChatButton = () => {
  const { t } = useTranslation('common');
  const { push, locale } = useRouter();
  const [opened, setOpened] = useState(false);

  const currentRegion = locale.substr(-2);
  const phoneNumberBinding = {
    HK: '+852 3590 5885',
    SG: '+65 6836 1110',
    VN: '+91 75500 46469',
    IN: '+84 028 7308 8995',
  };
  const description = `${t('cs_hotline')} ${phoneNumberBinding[currentRegion]}`;

  const handleButtonClicked = () => {
    if (opened) {
      push(`tel:${phoneNumberBinding[currentRegion]}`);
    } else {
      setOpened(true);
    }
  };

  const handleCloseToggled = (e) => {
    e.stopPropagation();

    setOpened(false);
  };

  return (
    <Container onClick={handleButtonClicked} opened={opened}>
      <PhoneContainer opened={opened}>
        <Icon sx={{ ml: 1, mt: 1, mb: 1.5 }}>phone</Icon>
      </PhoneContainer>
      <DescriptionContainer opened={opened}>
        <TextContainer>{description}</TextContainer>
        <IconContainer onClick={handleCloseToggled}>
          <Icon sx={{ mt: 0.9, mr: 2 }}>close</Icon>
        </IconContainer>
      </DescriptionContainer>
    </Container>
  );
};

export default FloatingChatButton;
